module.exports = require("tmp");


//////////////////
// WEBPACK FOOTER
// external "tmp"
// module id = 192
// module chunks = 0